<section class=" section">
    <!-- Container Start -->
    <div class="container container-xs">
        <div class="row">
            <div class="col-xxl-10 offset-xxl-1 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-xs-12">
                <!-- Section title -->
                <div class="row" *ngIf="(isAdmin || isContribuidor)">
                    <button type="button" (click)="habilitarOrdenar()" data-toggle="tooltip" title="Habilitar Ordenamiento" *ngIf="isAdmin && !ordenar && burbujas.length>0" class="btn btn-outline-primary ordenar  btn-sm"><i class="fas fa-sort"></i> Ordenar</button>
                    <button type="button" (click)="nuevaBurbuja()" data-toggle="tooltip" title="Nueva Burbuja" *ngIf="(isAdmin||isContribuidor) && editar" class="btn btn-primary nuevaburbuja  btn-sm"><i class="fas fa-plus"></i> Nueva burbuja</button>
                    <button type="button" (click)="cancelarOrdenar()" *ngIf="isAdmin && ordenar" class="btn btn-outline-primary deshabilitar  btn-sm"><i class="fas fa-times"></i> Cancelar</button>
                    <button type="button" (click)="guardarOrdenamiento()" *ngIf="isAdmin && ordenar" class="btn btn-outline-success guardar  btn-sm"><i class="far fa-save"></i> Guardar</button>
                </div>
                <div class="row mt-3">
                    <ul class="btn-toggle-nav list-unstyled fw-normal contburbu" cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!ordenar" [cdkDropListData]="burbujas">
                        <li class="h1burbu" *ngFor="let burbuja of burbujas; let i = index" cdkDrag>
                            <h2 (mouseenter)="hoveredIndex = i" (mouseleave)="hoveredIndex = null">
                                <a>
                                    <a (click)="verTemas(burbuja.id, burbuja.descripcion)" class="icono_burbuja">
                                        {{burbuja.descripcion}}
                                    </a>
                                    <a (click)="editarBurbuja(burbuja.id)" *ngIf="(isAdmin||isContribuidor) && editar && hoveredIndex == i" class="btn_ico">
                                        <i class="far fa-edit"></i>
                                    </a>
                                    <a (click)="borrarBurbuja(burbuja.id, burbuja.descripcion)" *ngIf="isAdmin && editar && hoveredIndex == i" class="btn_ico">
                                        <i class="far fa-trash-alt"></i>
                                    </a>
                                    <a (click)="verTemas(burbuja.id, burbuja.descripcion)">
                                        <i class="fas fa-chevron-right mr-1 ml-1 letsgo"></i>
                                    </a>
                                </a>
                            </h2>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
        <br>
        <app-loading *ngIf="loading" class="m-5"></app-loading>
    </div>
    <!-- Container End -->
</section>